import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { map, switchMap } from "rxjs/operators";
import { ModalComponent } from "src/app/shared/components/modal/modal.component";
import { environment } from "src/environments/environment";
import { ProfileService } from "../profile/profile.service";
import { UserManagementService } from "./user-management.service";

@Component({
  selector: 'lifedi-modal-account',
  templateUrl: './modal-account.component.html',
  styleUrls: ['./user-management.component.scss']

})
export class ModalAccountComponent {
  modalData: any;
  msgError: string = null;
  experties;
  date: Date;
  age: number;
  confirmModalDialog;
  isEdit: boolean = false;
  userAccountForm: FormGroup;
  teacherAccountForm: FormGroup;
  psychologistAccountForm: FormGroup;
  adminAccountForm: FormGroup;
  btnHistoryStyle: string = "width: 100px; border: 2px solid #060E9F"
  personalDescription;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    maxHeight: 'auto',
    width: '80%;',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'ใส่ประวัติ และ ความสนใจของคุณ',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  }


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalAccountComponent>,
    public matDialog: MatDialog,
    private profileService: ProfileService,
    private userManagementService: UserManagementService,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer
  ) {
    if (data.status === 'Active') {
      data.digitStatus = true;
      data.readOnly = false;
    } else if (data.status === 'Ban') {
      data.digitStatus = false;
      data.readOnly = false;
    } if (data.status === 'Wait Verify' || data.status === 'Deactivate') {
      data.readOnly = true;
    }

    if (data.role === 'user') {
      this.userAccountForm = this.fb.group({
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
      })
    } else if (data.role === 'teacher') {
      this.teacherAccountForm = this.fb.group({
        username: ['', Validators.required],
        gender: [''],
        dateOfBirth: [''],
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
        phoneNO: ['', Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")],
        experties: ['',],
        description: ['', Validators.required],
      })
      this.personalDescription = this.sanitizer.bypassSecurityTrustHtml(data.row.PERSONAL_DESCRIPTION);
      this.getExpertie();
    } else if (data.role === 'psychologist') {
      this.psychologistAccountForm = this.fb.group({
        username: ['', Validators.required],
        gender: [''],
        dateOfBirth: [''],
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
        phoneNO: ['', Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")],
        experties: [''],
        description: ['', Validators.required],
      })
      this.personalDescription = this.sanitizer.bypassSecurityTrustHtml(data.row.PERSONAL_DESCRIPTION);
      this.getExpertie();
    } else if (data.role === 'admin') {
      this.adminAccountForm = this.fb.group({
        username: ['', Validators.required],
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
        gender: [''],
        dateOfBirth: [''],
        phoneNO: ['', Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")],
      })
    }

    this.modalData = data;
    // console.log(this.modalData);

    if (this.modalData.row.DATE_OF_BIRTH && this.modalData.row.DATE_OF_BIRTH !== '0000-00-00') {
      this.date = new Date(this.modalData.row.DATE_OF_BIRTH);
      this.age = this.calculateAge(this.date);
    }
  }

  get tf() {
    return this.teacherAccountForm.controls;
  }

  get pf() {
    return this.psychologistAccountForm.controls;
  }

  get af() {
    return this.adminAccountForm.controls;
  }

  actionFunction() {
    let ActiveStatus: number;
    let updateProfile;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modalConfirm";
    dialogConfig.width = "350px";
    dialogConfig.data = {
      title: "แก้ไขข้อมูล",
      description: "คุณต้องการแก้ไขข้อมูล?",
      actionBtnText: "ยืนยัน",
      cancleBtnText: "ยกเลิก"
    }
    this.confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    this.confirmModalDialog.afterClosed().subscribe(res => {

      if (this.modalData.digitStatus) {
        ActiveStatus = 0;
      } else {
        ActiveStatus = 4;
      }

      if (res) {
        // // console.log(this.modalData);
        if (this.modalData.role === 'user') {

          const body = {
            USER_ID: this.modalData.id,
            USERNAME: this.modalData.row.USERNAME,
            EMAIL: this.userAccountForm.value.email,
            GENDER: this.modalData.row.GENDER,
            DATE_OF_BIRTH: this.modalData.row.DATE_OF_BIRTH,
            ACTIVE_USER: ActiveStatus
          }
          updateProfile = this.userManagementService.updateProfileUser(body);

        } else if (this.modalData.role === 'teacher') {
          let exp = null;
          let date = null;
          if (this.teacherAccountForm.value.experties === '') {
            exp = this.modalData.row.EXPERTIES;
          } else {
            exp = this.teacherAccountForm.value.experties;
          }

          for (let i = 0; i < exp.length; i++) {
            delete exp[i]['ID']
            delete exp[i]['USER_ID']
          }
          // // console.log(this.teacherAccountForm);

          if (this.teacherAccountForm.value.dateOfBirth) {
            date = new Date(this.teacherAccountForm.value.dateOfBirth);
          }

          const body = {
            ROLE: this.modalData.role,
            USER_ID: this.modalData.id,
            USERNAME: this.teacherAccountForm.value.username,
            EMAIL: this.teacherAccountForm.value.email,
            GENDER: this.teacherAccountForm.value.gender,
            DATE_OF_BIRTH: date,
            ACTIVE_USER: ActiveStatus,
            EXPERTIES: exp,
            PHONENUMBER: this.teacherAccountForm.value.phoneNO,
            PERSONAL_DESCRIPTION: this.teacherAccountForm.value.description
          }
          updateProfile = this.userManagementService.updateProfileTeaOrPsy(body);

        } else if (this.modalData.role === 'psychologist') {
          let exp = null;
          let date = null;
          if (this.psychologistAccountForm.value.experties === '') {
            exp = this.modalData.row.EXPERTIES;
          } else {
            exp = this.psychologistAccountForm.value.experties;
          }

          for (let i = 0; i < exp.length; i++) {
            delete exp[i]['ID']
            delete exp[i]['USER_ID']
          }

          if (this.psychologistAccountForm.value.dateOfBirth) {
            date = new Date(this.psychologistAccountForm.value.dateOfBirth);
          }

          const body = {
            ROLE: this.modalData.role,
            USER_ID: this.modalData.id,
            USERNAME: this.psychologistAccountForm.value.username,
            EMAIL: this.psychologistAccountForm.value.email,
            GENDER: this.psychologistAccountForm.value.gender,
            DATE_OF_BIRTH: date,
            ACTIVE_USER: ActiveStatus,
            EXPERTIES: exp,
            PHONENUMBER: this.psychologistAccountForm.value.phoneNO,
            PERSONAL_DESCRIPTION: this.psychologistAccountForm.value.description
          }
          updateProfile = this.userManagementService.updateProfileTeaOrPsy(body);

        } else if (this.modalData.role === 'admin') {
          let date = null;

          if (this.adminAccountForm.value.dateOfBirth) {
            date = new Date(this.adminAccountForm.value.dateOfBirth);
          }

          const body = {
            ADMIN_ID: this.modalData.id,
            USERNAME: this.adminAccountForm.value.username,
            EMAIL: this.adminAccountForm.value.email,
            GENDER: this.adminAccountForm.value.gender,
            DATE_OF_BIRTH: date,
            PHONENUMBER: this.adminAccountForm.value.phoneNO,
            ACTIVE_USER: ActiveStatus
          }
          updateProfile = this.userManagementService.updateProfileAdmin(body);

        }
        updateProfile.subscribe(res => {
          if (res) {
            return this.dialogRef.close(true);
          }
        }, err => {
          this.msgError = err.error.message
          alert(err.error.message);
        });
      }
    })
  }

  closeModal() {
    this.dialogRef.close(false);
  }

  changeStatus(e) {
    if (!e.checked) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = "modalConfirm";
      dialogConfig.width = "500px";
      dialogConfig.data = {
        title: "แบนผู้ใช้งาน",
        description: "คุณต้องการแบน " + this.modalData.name + " ผู้ใช้งานจะไม่สามารถเข้าระบบได้อีก",
        actionBtnText: "ยืนยัน",
        cancleBtnText: "ยกเลิก"
      }
      this.confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
      this.confirmModalDialog.afterClosed().subscribe(res => {
        if (!res) {
          this.modalData.digitStatus = true;
        }
      })
    } else if (e.checked) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.id = "modalConfirm";
      dialogConfig.width = "500px";
      dialogConfig.data = {
        title: "ยกเลิกการแบนผู้ใช้งาน",
        description: "คุณต้องการยกเลิกการแบน " + this.modalData.name + " ผู้ใช้งานจะสามารถเข้าระบบได้ปกติ",
        actionBtnText: "ยืนยัน",
        cancleBtnText: "ยกเลิก"
      }
      this.confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
      this.confirmModalDialog.afterClosed().subscribe(res => {
        if (!res) {
          this.modalData.digitStatus = false;
        }
      })
    }
  }

  getExpertie() {
    this.profileService.getExpertie().subscribe(e => {
      let exp: any = e
      this.experties = exp.result;
    })
  }

  toggleEdit() {
    this.isEdit = !this.isEdit;
  }

  getSelectedItem(e, profile) {
    profile.controls['experties'].setValue(e.listOfValue);
  }

  delete(id, role) {
    const body = {
      ROLE: role,
      USER_ID: id,
      STATUS: 1
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modalConfirm";
    dialogConfig.autoFocus = false;
    dialogConfig.width = "500px";
    dialogConfig.data = {
      title: "ลบผู้ใช้งาน",
      description: "คุณต้องการลบ " + this.modalData.name + " ผู้ใช้งานจะไม่สามารถเข้าสู่ระบบได้อีก",
      actionBtnText: "ลบ",
      cancleBtnText: "ยกเลิก",
      isDelete: true
    }
    this.confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    this.confirmModalDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.userManagementService.updateStatusAccount(body).pipe(
            map(() => {
              this.closeModal();
            })
          )
        }
      })
    ).subscribe();
  }

  reactivate(id, role) {
    const body = {
      ROLE: role,
      USER_ID: id,
      STATUS: 0
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modalConfirm";
    dialogConfig.autoFocus = false;
    dialogConfig.width = "500px";
    dialogConfig.data = {
      title: "กู้คืนบัญชีผู้ใช้งาน",
      description: "คุณต้องการกู้คืนบัญชี " + this.modalData.name + " ผู้ใช้งานจะสามารถเข้าสู่ระบบได้ปกติ",
      actionBtnText: "ยืนยัน",
      cancleBtnText: "ยกเลิก",
    }
    this.confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    this.confirmModalDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.userManagementService.updateStatusAccount(body).pipe(
            map(() => {
              this.closeModal();
            })
          )
        }
      })
    ).subscribe();
  }


  calculateAge(birthday) {
    const today = new Date()
    const birthDate = new Date(birthday)
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.EXPERTIE_ID === i2.EXPERTIE_ID : i1 === i2;
  }

  openHistory(type) {
    window.open(`user-management/${type}?user_id=${this.modalData.id}`);
  }
}

